var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartOptions)?_c('apexchart',{staticClass:"p-12 text-2xl m-12",attrs:{"type":"pie","height":"640","id":"chart","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }